import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

const URI_PREFIX = checkIsStoryBookPath('auth');

export const apiRoutes = {
  /* inject path */
  refreshToken: `${URI_PREFIX}/token/refresh`,
  login: `${URI_PREFIX}/login`,
  authorizedModules: `${URI_PREFIX}/authorized/modules`,
  logout: `${URI_PREFIX}/logout`,
  forgotPassword: `${URI_PREFIX}/init-reset-password`,
  verifyResetPasswordToken: `${URI_PREFIX}/verify-reset-password-token`,
  resetPassword: `${URI_PREFIX}/reset-new-password`,
  twoFactorLogin: `${URI_PREFIX}/two-factor-login`,
};
